import { createContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ModuleContextProvider } from './ModuleContext';
import { AppsContextProvider } from './AppsContext';
import { DigibookContextProvider } from './DigibookContext';
import { TableOfContentsContextProvider } from '../toc/_contexts/TableOfContentsContext';
import { ModalContextProvider } from '../../../contexts/ModalContext';

type MaterialDataContextValue = {
  selectedNodeIds: string[];
  setSelectedNodeIds: React.Dispatch<React.SetStateAction<string[]>>;
};

export const MaterialDataContext = createContext<MaterialDataContextValue>({
  selectedNodeIds: [],
  setSelectedNodeIds: () => {},
});

export default function MaterialDataProvider() {
  const [selectedNodeIds, setSelectedNodeIds] = useState<string[]>([]);

  return (
    <MaterialDataContext.Provider
      value={{
        selectedNodeIds,
        setSelectedNodeIds,
      }}
    >
      <ModuleContextProvider>
        <TableOfContentsContextProvider>
          <AppsContextProvider>
            <DigibookContextProvider>
              <ModalContextProvider>
                <Outlet />
              </ModalContextProvider>
            </DigibookContextProvider>
          </AppsContextProvider>
        </TableOfContentsContextProvider>
      </ModuleContextProvider>
    </MaterialDataContext.Provider>
  );
}
